"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingSwitchButtonWrap = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styles_1 = require("@material-ui/styles");
var styles_2 = require("@material-ui/core/styles");
var Switch_1 = tslib_1.__importDefault(require("@material-ui/core/Switch"));
var FormGroup_1 = tslib_1.__importDefault(require("@material-ui/core/FormGroup"));
var Typography_1 = tslib_1.__importDefault(require("@material-ui/core/Typography"));
var useStyles = styles_1.makeStyles({
    Wrap: {
        width: "100%",
        height: 44,
    },
    SwitchButton: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
    },
});
var AntSwitch = styles_2.withStyles(function (theme) {
    return styles_2.createStyles({
        root: {
            width: 30,
            height: 18,
            padding: 0,
            display: "flex",
        },
        switchBase: {
            padding: 1,
            color: "white",
            "&$checked": {
                transform: "translateX(12px)",
                color: theme.palette.common.white,
                "& + $track": {
                    opacity: 1,
                    backgroundColor: "rgba(111,139,215,1)",
                    borderColor: theme.palette.primary.main,
                },
            },
        },
        thumb: {
            width: 16,
            height: 16,
            boxShadow: "none",
        },
        track: {
            borderRadius: 16,
            opacity: 1,
            backgroundColor: "rgba(108,112,114,1)",
        },
        checked: {},
    });
})(Switch_1.default);
function SettingSwitchButtonWrap(props) {
    var onChange = props.onChange, other = tslib_1.__rest(props, ["onChange"]);
    var classes = useStyles();
    var handleChange = function (event) {
        onChange(event);
    };
    return (React.createElement("div", { className: classes.SwitchButton },
        React.createElement(FormGroup_1.default, null,
            React.createElement(Typography_1.default, { component: "div" },
                React.createElement(AntSwitch, tslib_1.__assign({ onChange: handleChange, value: "checked" }, other))))));
}
exports.SettingSwitchButtonWrap = SettingSwitchButtonWrap;
//# sourceMappingURL=SettingSwitchButtonWrap.js.map